import { fetchAuthedApiResponse } from './http';

export interface DeveloperEmployeePayload {
  username: string;
  full_name: string;
  password: string;
  role: string;
  email?: string | null;
  phone?: string | null;
  branch?: string | null;
}

export function fetchDeveloperSimulationStateResponse(): Promise<Response> {
  return fetchAuthedApiResponse('/api/developer/simulation/state', { autoLogout: false });
}

export function fetchDeveloperErrorDetailResponse(errorId: number): Promise<Response> {
  return fetchAuthedApiResponse(`/api/developer/errors/${errorId}`, { autoLogout: false });
}

export function startDeveloperSimulationResponse(payload: Record<string, unknown>): Promise<Response> {
  return fetchAuthedApiResponse('/api/developer/simulation/start', {
    method: 'POST',
    autoLogout: false,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function stopDeveloperSimulationResponse(): Promise<Response> {
  return fetchAuthedApiResponse('/api/developer/simulation/stop', {
    method: 'POST',
    autoLogout: false,
  });
}

export function clearDeveloperErrorResponse(errorId: number): Promise<Response> {
  return fetchAuthedApiResponse(`/api/developer/errors/${errorId}`, {
    method: 'DELETE',
    autoLogout: false,
  });
}

export function clearAllDeveloperErrorsResponse(): Promise<Response> {
  return fetchAuthedApiResponse('/api/developer/errors', {
    method: 'DELETE',
    autoLogout: false,
  });
}

export function createDeveloperEmployeeResponse(payload: DeveloperEmployeePayload): Promise<Response> {
  return fetchAuthedApiResponse('/api/developer/employees', {
    method: 'POST',
    autoLogout: false,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
